import { Button, Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import * as React from "react";
import { useHistory } from "react-router-dom";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const useStyles = makeStyles((theme: Theme) => ({
  buttonStyle: {
    "color": theme.palette.primary.main,
    "marginTop": -9,
    "border": "0px solid",
    "borderRadius": "3px",
    "padding": 8,
    "height": 32,
    "marginRight": "1.5rem",
    "fontSize": 16,
    "textAlign": "left",
    "&:focus, &:hover": {
      "color": theme.palette.primary.main,
      "backgroundColor": "#E6F3FF",
      "& svg": {
        color: theme.palette.primary.main,
        backgroundColor: "transparent",
        borderRadius: "50%",
      },
    },
    "& svg": {
      color: "#ACC8DF",
    },
    "&:active": {
      "backgroundColor": theme.palette.primary.main,
      "color": "#fff",

      "& *": {
        color: "#fff",
        textDecoration: "none",
      },
      "& circle": {
        fill: "transparent",
      },
    },
  },
}));

export default function HelpButton(appName: any) {
  const classes = useStyles();
  const history = useHistory();
  const path = window.location.pathname
    .split("/")
    .filter((path: string) => path !== "");
  const pathName = path.splice(1, 10).join("/");
  return (
    <Button
      color="primary"
      disableElevation
      className={classes.buttonStyle}
      aria-label={`View help for BankFind.`}
      id={`view-help-link-BankFind`}
      onClick={() =>
        history.push({
          pathname: `/help`,
          state: {
            url: pathName + window.location.search,
          },
        })
      }
    >
      Help
      <HelpOutlineIcon style={{ marginLeft: 5, zIndex: 100 }} />
      <svg height="24" width="24" style={{ marginLeft: -24 }}>
        <circle cx="12" cy="12" r="10" fill="white" />
      </svg>
    </Button>
  );
}
